module.exports = __webpack_public_path__ + "img/ACADEMY.5f745de9.svg";